import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Platform } from '@ionic/angular';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit {
  @Input() pdfUrl: string;
  pdfSrc: SafeResourceUrl;
  isMobileView: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private modalController: ModalController,
    private platform: Platform
  ) { }

  ngOnInit() {
    if (this.pdfUrl) {
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl);
    }

    this.isMobileView = window.innerWidth < 576;
  }

  closePdf() {
    console.log('PDF Viewer Closed');
    this.modalController.dismiss();
  }

  /* async downloadPdf() {
    if (this.platform.is('cordova') || this.platform.is('android') || this.platform.is('ios')) {
      const fileUrl = this.pdfUrl;
      const fileName = fileUrl.split('/').pop();

      try {
        const fileData = await this.fetchPdf(fileUrl);
        await this.saveFile(fileData, fileName);
        await this.openFile(fileName);
      } catch (error) {
        console.error('Download failed: ', error);
        alert('Download failed: ' + error);
      }
    } else {
      const link = document.createElement('a');
      link.href = this.pdfUrl;
      link.download = 'PDPA.pdf';
      link.click();
    }
  } */

    async downloadPdf() {
  if (this.isMobileBrowser()) {
    // Open in a new tab for mobile browsers (Safari/Chrome)
    window.open(this.pdfUrl, '_blank');
    return;
  }

  // Desktop fallback: force download
  const link = document.createElement('a');
  link.href = this.pdfUrl;
  link.download = 'PDPA.pdf';
  link.click();
}

isMobileBrowser(): boolean {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  return /android|iphone|ipad|ipod|windows phone/i.test(userAgent.toLowerCase());
}

  private async fetchPdf(url: string): Promise<Blob> {
    try {
      let blob: Blob;
      const base64Pattern = /^data:application\/pdf;base64,/;
      if (base64Pattern.test(url)) {
        const base64Data = url.split(',')[1];
        blob = this.base64ToBlob(base64Data, 'application/pdf');
      } else {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch PDF. Status: ${response.status}`);
        }
        console.log('PDF fetched successfully', response);
        blob = await response.blob();
        const contentType = response.headers.get('Content-Type');
        if (contentType !== 'application/pdf') {
          throw new Error('The fetched content is not a PDF.');
        }
      }

      console.log('Blob size:', blob.size);

      return blob;
    } catch (error) {
      console.error('Error fetching PDF:', error);
      throw error;
    }
  }

  private base64ToBlob(base64: string, mimeType: string): Blob {
    const binary = atob(base64);
    const length = binary.length;
    const buffer = new ArrayBuffer(length);
    const view = new Uint8Array(buffer);

    for (let i = 0; i < length; i++) {
      view[i] = binary.charCodeAt(i);
    }

    return new Blob([buffer], { type: mimeType });
  }

  private async saveFile(fileData: Blob, fileName: string) {
    const base64 = await this.blobToBase64(fileData);

    const cleanBase64 = base64.split(',')[1];

    await Filesystem.writeFile({
      path: fileName,
      data: cleanBase64,
      directory: Directory.Documents,
    });

    console.log('File saved successfully');
  }

  private async blobToBase64(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  private async openFile(fileName: string) {
    try {
      const filePath = await Filesystem.getUri({
        path: fileName,
        directory: Directory.Documents,
      });

      console.log('File path:', filePath.uri);

      await FileOpener.openFile({
        path: filePath.uri,
        mimeType: 'application/pdf',
      });

      console.log('File opened successfully');
    } catch (error) {
      console.error('Error opening file:', error);
      alert('Error opening the file: ' + error);
    }
  }
}